import React from "react";

import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";

import img3 from "../../images/aboutpic.png";
const About = () => {
  return (
    <div className="QL__PG__AboutSec">
      <Container>
        <Box>
          <Grid container spacing={8}>
            <Grid item xs={12} md={6}>
              <Box sx={{ display: { xs: "none", md: "flex" } }}>
                <img className="QL__PG__Sec__Img" src={img3}></img>
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <h1 className="HeadingAll">About us</h1>
              <p className="pt-3">
                At LearnQuranQuick, we are determined to provide a platform that
                would prove to be beneficial for the people to learn Quran in an
                engaging, effective, and intriguing manner.
                LearnQuranQuick is an online Quran learning platform. It provides online Quran
                learning classes so that people can learn and read the Quran
                whenever and wherever they please! With the addition of features
                like ‘Recorded classes’ and ‘Weekend-based classes’,
                LearnQuranQuick gives people the comfort of staying connected to
                Islam even in the busiest of schedules.
              </p>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box sx={{ display: { xs: "flex", md: "none" } }}>
                <img src={img3} alt="reading image" />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </div>
  );
};
export default About;
